module.exports = __webpack_public_path__ + "static/img/logo-hexagon-black.53eeb5a7.svg";